module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_show),
      expression: "is_show"
    }],
    staticClass: "cancel_order"
  }, [_c('div', {
    staticClass: "cancel_dialog"
  }, [(_vm.is_logout) ? _c('div', {
    staticClass: "logout_title"
  }, [_c('p', [_vm._v("当前账号"), _c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.user_real_phone))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.title))])]) : _c('div', {
    staticClass: "common_title",
    attrs: {
      "name": "header"
    }
  }, [(_vm.title) ? _c('h3', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.subTitle) ? _c('p', [_vm._v(_vm._s(_vm.subTitle))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "common_content"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "common_btn",
    attrs: {
      "name": "footer"
    }
  }, [_c('div', {
    class: {
      common_btn_left: _vm.colorType == 'left'
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.leftContent))]), _vm._v(" "), _c('div', {
    class: {
      common_btn_right: _vm.colorType == 'left'
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.rightContent))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7951d06b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Confirm.vue
// module id = 510
// module chunks = 39